import React from "react";
import { BsFillClipboardCheckFill } from "react-icons/bs";
const CopiedNotification = () => {
  return (
    <div className="notification">
      <span style={{fontFamily:"Inter"}}>Copied to clipboard</span>
      <span>
        <BsFillClipboardCheckFill />
      </span>
    </div>
  );
};

export default CopiedNotification;
